// Lazy loading: an element with class lazy loads the URL in its data-src (as its src, or for any other element its
// background image) once it comes within 1000px above or below the window. Images marked up with loading="lazy" are
// left to the browser; this is for the ones with a placeholder, and for background images.
//
// WebP (see ImagesHelper): an <img> inside a <picture> also gets its <source data-srcset>s filled in, so the browser
// picks the WebP (at the right width) if it can. A background image with data-src-webp (and data-src-webp-2x, for
// high-density screens) is set to the PNG and then to an image-set() preferring the WebP; browsers that don't
// understand image-set() with type() ignore that and keep the PNG, and the ones that do all support WebP.
function reveal(element) {
  const source = element.getAttribute('data-src')
  if (!source) return
  if (element.tagName === 'IMG') {
    const picture = element.parentElement
    if (picture && picture.tagName === 'PICTURE') {
      picture.querySelectorAll('source[data-srcset]').forEach((s) => s.setAttribute('srcset', s.getAttribute('data-srcset')))
    }
    element.setAttribute('src', source)
  } else {
    element.style.backgroundImage = 'url("' + source + '")'
    const webp = element.getAttribute('data-src-webp')
    if (webp) {
      const webp2x = element.getAttribute('data-src-webp-2x')
      const options = ['url("' + webp + '") type("image/webp") 1x']
      if (webp2x && webp2x !== webp) options.push('url("' + webp2x + '") type("image/webp") 2x')
      options.push('url("' + source + '") type("image/png") 1x')
      element.style.backgroundImage = 'image-set(' + options.join(', ') + ')'
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return
      observer.unobserve(entry.target)
      reveal(entry.target)
    })
  }, { rootMargin: '1000px 0px' })

  document.querySelectorAll('.lazy').forEach((element) => observer.observe(element))
})
